import React from "react";
import {
  Dollar,
  Calender,
  refresh,
  wallet,
  Bank,
  info,
} from "./../../../Public/assets/index";
import { useOverview } from "./../../../hooks";
import { formatCurrency, reFormatDate } from "./../../../Utils/helperFunction";

const WalletSummary = () => {
  const {
    amount,
    selectedCurrency,
    getFlagByCurrencyCode,
    selectedToCurrency,
    charges,
    toAmount,
  } = useOverview();

  const getFeeDisplay = () => {
    if (!charges?.totalFees || charges.totalFees === "-") {
      return "-";
    }

    // Check if totalFees is "0" or "0.0" or "0.00"
    const isZero = parseFloat(charges.totalFees) === 0;

    if (isZero) {
      return "Free";
    }

    return `${charges.totalFees} ${selectedCurrency?.vendorCurrency}`;
  };

  return (
    <div className=" py-[25px]">
      <div className=" flex flex-col gap-5 relative overflow-hidden">
        <div className="absolute left-4 top-0 bottom-0 border-l-2 border-dotted h-auto  border-greyish"></div>
        <div className="space-y-1">
          <div className="absolute left-2 top-0 bg-white ">
            <div className="bg-white text-greyish">
              <img src={wallet} alt="" />
            </div>
          </div>
          <p className="text-xs font-normal  pl-10 text-greyish">From Amount</p>

          <div className="ml-10 mt-1 space-y-1 ">
            <p className="text-base  flex   gap-1.5 font-geomanistBold text-[#22212E]">
              {amount} {selectedCurrency?.vendorCurrency}
              <img
                src={getFlagByCurrencyCode(selectedCurrency?.vendorCurrency)}
                alt=""
                className="rounded-full my-auto w-[18px] h-[18px]"
              />
            </p>
            <p className="text-[12px] font-normal text-greyish">
              Account Balance:{" "}
              {formatCurrency(
                parseFloat(
                  selectedCurrency?.balance - selectedCurrency?.holdBalance
                ).toFixed(2)
              )}{" "}
              {selectedCurrency?.vendorCurrency}
            </p>
          </div>
        </div>
        <div className="py-2">
          <div className="absolute left-2 bg-white">
            <div className="">
              <img src={Calender} alt="" />
            </div>
          </div>

          <div className="ml-10">
            <div className="flex  space-y-1  flex-col justify-center ">
              <p className=" flex  items-center text-xs  gap-2  font-normal text-greyish ">
                Transfer On
                <span className="text-xs font-normal text-blackShade">
                  {reFormatDate(new Date())}
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="py-2">
          <div className="absolute left-2  bg-white">
            <img src={refresh} alt="" />
          </div>
          <div className="space-y-2 pl-10">
            <div className=" ">
              <p className="text-xs  flex items-center gap-2 font-normal text-[#797979]  ">
                Conversion Rate:
                <span className="text-base  flex gap-3 font-geomanistBold text-blackShade">
                  1 {selectedCurrency?.vendorCurrency} = {charges?.rate}{" "}
                  {selectedToCurrency?.vendorCurrency}
                </span>
                <div className="relative group">
                  <img src={info} alt="" />
                  <div className="absolute left-1/2 -translate-x-1/2  hidden group-hover:block bottom-full w-max  mb-2  bg-blueish font-geomanistBold  text-white text-xs  leading-[24px] rounded px-2 py-1">
                    Actual rate may vary
                    <div className="absolute bottom--2 left-1/2 -translate-x-1/2 w-2 h-2 bg-blueish rotate-45 transform"></div>
                  </div>
                </div>
              </p>
            </div>
          </div>
        </div>

        <div className="py-2">
          <div className="absolute left-1.5 bg-white">
            <img src={Dollar} alt="" />
          </div>
          <div className="space-y-2 pl-10">
            <div className="flex items-center space-x-2">
              <p className="flex  items-center gap-2 text-xs font-normal text-greyish  ">
                Conversion Fee:{" "}
                <span className=" text-base  flex gap-3 font-geomanistBold text-blackShade">
                  {getFeeDisplay()}
                </span>
                {(!getFeeDisplay() === "-" || getFeeDisplay() === "FREE") && (
                  <div className="relative group">
                    <img src={info} alt="" />
                    <div className="absolute left-1/2 -translate-x-1/2  hidden group-hover:block bottom-full w-max  mb-2  bg-blueish font-geomanistBold  text-white text-xs  leading-[24px] rounded px-2 py-1">
                      Actual fee may vary depending on the rate
                      <div className="absolute bottom--2 left-1/2 -translate-x-1/2 w-2 h-2 bg-blueish rotate-45 transform"></div>
                    </div>
                  </div>
                )}
              </p>
            </div>
          </div>
        </div>
        <div className="py-2">
          <div className="absolute left-2 bg-white h-full ">
            <img src={Bank} alt="" />
          </div>
          <div className="space-y-2 pl-10">
            <p className="text-xs font-normal   text-greyish">To Amount</p>

            <div className=" mt-1 space-y-1 ">
              <p className="text-base  flex gap-3 font-geomanistBold text-blackShade">
                {toAmount} {selectedToCurrency?.vendorCurrency}
                <img
                  src={getFlagByCurrencyCode(
                    selectedToCurrency?.vendorCurrency
                  )}
                  alt=""
                  className="rounded-full my-auto w-[18px] h-[18px] "
                />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletSummary;
